import authReducer from 'Features/Auth/authSlice'
import paymentReducer from 'Features/Payment/paymentSlice'
import searchReduer from 'Features/Search/searchSlice'
import { configureStore } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    search: searchReduer,
    payment: paymentReducer
  }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch = () => useDispatch<AppDispatch>() // Export a hook that can be reused to resolve types